import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/password/forgot", { email: email.trim().toLowerCase() }); setSent(true); }
    catch (err) { toast.error(err?.response?.data?.detail || "İstek başarısız"); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#faf7f2] flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-md card-lux p-8" data-testid="forgot-root">
        <div className="mb-4"><Link to="/login" className="text-xs text-stone-500 hover:text-amber-700 inline-flex items-center gap-1"><ArrowLeft className="w-3 h-3" /> Girişe dön</Link></div>
        <div className="flex items-center gap-2 mb-3"><Mail className="w-5 h-5 text-amber-700" /><h1 className="font-serif-display text-2xl">Şifremi Unuttum</h1></div>
        {!sent ? (
          <>
            <p className="text-xs text-stone-500 mb-3">Owner e-posta adresinizi girin. E-postanız kayıtlıysa 30 dakika geçerli tek-kullanımlık bir sıfırlama token'ı gönderilir.</p>
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mb-4 px-4 py-3 rounded-lg border border-stone-200 outline-none focus:border-amber-500" placeholder="owner@rivaco.com" />
            <button data-testid="forgot-submit" type="submit" disabled={busy || !email.includes("@")} className="w-full py-3 rounded-lg gold-gradient text-white disabled:opacity-60">{busy ? "Gönderiliyor..." : "Sıfırlama Token'ı Gönder"}</button>
          </>
        ) : (
          <div data-testid="forgot-sent" className="text-sm text-stone-700">
            <p className="mb-3">Eğer e-postanız kayıtlıysa, sıfırlama token'ı gönderildi. Gelen kutunuzu (ve spam klasörünü) kontrol edin.</p>
            <Link data-testid="forgot-to-reset" to="/sifre-sifirla" className="inline-block py-2 px-4 rounded-lg gold-gradient text-white text-sm">Şifre Sıfırla Ekranına Git</Link>
          </div>
        )}
      </form>
    </div>
  );
}
